import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, Router } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { NgChartsModule } from 'ng2-charts';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../environments/environment';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from './shared/shared.module';
import { IonCustomScrollbarModule } from 'ion-custom-scrollbar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PpAssignListComponent } from './pp/add-pp/pp-assign-list/pp-assign-list.component';
import { PpAssignAddComponent } from './pp/add-pp/pp-assign-add/pp-assign-add.component';
import { PpAssignDetailComponent } from './pp/add-pp/pp-assign-detail/pp-assign-detail.component';
import { ListPpComponent } from './pp/assign-pp/list-pp/list-pp.component';
import { DetailPpComponent } from './pp/assign-pp/detail-pp/detail-pp.component';
import { AddPpComponent } from './pp/assign-pp/add-pp/add-pp.component';
import { ValidasiPpComponent } from './pp/validasi-pp/validasi-pp/validasi-pp.component';
import { ValidasiPpDetailComponent } from './pp/validasi-pp/validasi-pp-detail/validasi-pp-detail.component';
import { AssignSurveyorComponent } from './assign/assign-surveyor/assign-surveyor.component';
import { AssignSurveyorDetailComponent } from './assign/assign-surveyor-detail/assign-surveyor-detail.component';
import { DelegasiListComponent } from './delegasi/delegasi-list/delegasi-list.component';
import { DelegasiModalSubmitComponent } from './delegasi/delegasi-modal-submit/delegasi-modal-submit.component';
import { DelegasiPindahDetailModalComponent } from './delegasi/delegasi-pindah-detail-modal/delegasi-pindah-detail-modal.component';
import { DelegasiPindahModalComponent } from './delegasi/delegasi-pindah-modal/delegasi-pindah-modal.component';
import { DelegasiSplitModalComponent } from './delegasi/delegasi-split-modal/delegasi-split-modal.component';
import { DelegasiRiwayatComponent } from './delegasi/delegasi-riwayat/delegasi-riwayat.component';
import { DelegasiRiwayatDetailModalComponent } from './delegasi/delegasi-riwayat-detail-modal/delegasi-riwayat-detail-modal.component';
import { ReportNasabahComponent } from './report/sales-report/report-nasabah/report-nasabah.component';
import { HasilSurveyComponent } from './report/surveyor-report/hasil-survey/hasil-survey.component';
import { DetailHasilSurveyComponent } from './report/surveyor-report/detail-hasil-survey/detail-hasil-survey.component';
import { DetailReportNasabahComponent } from './report/sales-report/detail-report-nasabah/detail-report-nasabah.component';
import { DetailReportPerformanceComponent } from './report/sales-report/detail-report-performance/detail-report-performance.component';
import { ReportPerformanceComponent } from './report/sales-report/report-performance/report-performance.component';
import { ReportPerformanceColComponent } from './report/collector-report/report-performance-col/report-performance-col.component';
import { DetailPerformanceColComponent } from './report/collector-report/detail-performance-col/detail-performance-col.component';
import { CompanyInterceptor } from './core/company/company.interceptor';
import { MaintenanceService } from './core/maintenance/maintenance.service';

export function initMaintenance(maintenance: MaintenanceService, router: Router) {
  return async () => {
    try {
      await maintenance.init();
    } catch {}

    if (maintenance.snapshot().active) {
      await router.navigateByUrl('/error-maintenance', { replaceUrl: true });
      return;
    }

    router.initialNavigation();
  };
}

@NgModule({
  declarations: [
    AppComponent,
    PpAssignListComponent,
    PpAssignAddComponent,
    PpAssignDetailComponent,
    ListPpComponent,
    DetailPpComponent,
    AddPpComponent,
    ValidasiPpComponent,
    ValidasiPpDetailComponent,
    AssignSurveyorComponent,
    AssignSurveyorDetailComponent,
    DelegasiListComponent,
    DelegasiModalSubmitComponent,
    DelegasiPindahDetailModalComponent,
    DelegasiPindahModalComponent,
    DelegasiSplitModalComponent,
    DelegasiRiwayatComponent,
    DelegasiRiwayatDetailModalComponent,
    ReportNasabahComponent,
    HasilSurveyComponent,
    DetailHasilSurveyComponent,
    DetailReportNasabahComponent,
    DetailReportPerformanceComponent,
    ReportPerformanceComponent,
    ReportPerformanceColComponent,
    DetailPerformanceColComponent,
  ],
  exports: [
    PpAssignListComponent,
    PpAssignAddComponent,
    PpAssignDetailComponent,
    ListPpComponent,
    DetailPpComponent,
    AddPpComponent,
    ValidasiPpComponent,
    ValidasiPpDetailComponent,
    AssignSurveyorComponent,
    AssignSurveyorDetailComponent,
    DelegasiListComponent,
    DelegasiModalSubmitComponent,
    DelegasiPindahDetailModalComponent,
    DelegasiPindahModalComponent,
    DelegasiSplitModalComponent,
    DelegasiRiwayatComponent,
    DelegasiRiwayatDetailModalComponent,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    IonCustomScrollbarModule,
    FormsModule,
    NgChartsModule,
    NgxPaginationModule,
    BrowserAnimationsModule,
    SharedModule,
    ReactiveFormsModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initMaintenance,
      deps: [MaintenanceService, Router],
      multi: true,
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: CompanyInterceptor, multi: true }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
